/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import EmailIcon from '@atlaskit/icon/core/migration/email';
import { N40, N500 } from '@atlaskit/theme/colors';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import React from 'react';
var getEmailAvatarWrapperStyle = function getEmailAvatarWrapperStyle(isLozenge) {
  var padding = isLozenge ? "var(--ds-space-0, 0px)" : "var(--ds-space-050, 4px)";
  return css({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: padding,
    backgroundColor: "var(--ds-background-neutral, ".concat(N40, ")"),
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    marginLeft: "var(--ds-space-025, 2px)"
  });
};
export var AddOptionAvatar = function AddOptionAvatar(_ref) {
  var isLozenge = _ref.isLozenge,
    label = _ref.label;
  return (
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    jsx("div", {
      css: getEmailAvatarWrapperStyle(isLozenge)
    }, jsx(EmailIcon, {
      testId: "add-option-avatar-email-icon",
      label: label || "",
      LEGACY_size: isLozenge ? 'small' : 'medium',
      LEGACY_margin: "0 0 0 -2px",
      color: "var(--ds-text-subtle, ".concat(N500, ")")
    }))
  );
};